import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { z } from 'zod'

import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'

export type TransferFromUserValidationIssue = 'exceeds-balance' | 'value-not-positive'

export interface GetTransferFromUserFormValidatorParams {
  tokenRepository: TokenRepository
  issueToMessage: Record<TransferFromUserValidationIssue, string>
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getTransferFromUserFormValidator<T extends GetTransferFromUserFormValidatorParams>({
  tokenRepository,
  issueToMessage,
}: T) {
  return AssetInputSchema.superRefine((field, ctx) => {
    const value = NormalizedNumber(field.value === '' ? '0' : field.value)
    const balance = tokenRepository.findOneBalance(field.symbol)

    const issue = validateTransferFromUser({
      value,
      user: { balance },
    })

    if (issue) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: issueToMessage[issue],
        path: ['value'],
      })
    }
  })
}

export interface ValidateTransferFromUserParams {
  value: NormalizedNumber
  user: {
    balance: NormalizedNumber
  }
}

export function validateTransferFromUser<T extends ValidateTransferFromUserParams>({
  value,
  user: { balance },
}: T): TransferFromUserValidationIssue | undefined {
  if (value.lte(0)) {
    return 'value-not-positive'
  }

  if (balance.lt(value)) {
    return 'exceeds-balance'
  }

  return undefined
}
